import app from 'flarum/common/app';
import extractText from 'flarum/common/utils/extractText';

/** What the server sends as `cadenceStreakRules` on the forum. */

/** The member's own flame, `cadenceFlame` on the session user. */

export function t(key, args) {
  if (args === void 0) {
    args = {};
  }
  return extractText(app.translator.trans(`ernestdefoe-cadence.forum.streak.${key}`, args));
}
export function rules() {
  return app.forum?.attribute('cadenceStreakRules') || null;
}
export function streaksOn() {
  return !!app.forum?.attribute('cadenceStreaks') && !!rules();
}

/** The highest tier a length reaches, or null below the first. */
export function tierFor(days) {
  let found = null;
  for (const tier of rules()?.tiers || []) if (days >= tier.days) found = tier;
  return found;
}
export function nextTier(days) {
  return (rules()?.tiers || []).find(tier => tier.days > days) || null;
}
const DEFAULT_TIERS = ['spark', 'kindled', 'blaze', 'inferno', 'eternal'];

/** Shared with the admin: `lib.*` keys are the ones both frontends load. */
export function lib(key, args) {
  if (args === void 0) {
    args = {};
  }
  return extractText(app.translator.trans(`ernestdefoe-cadence.lib.streak.${key}`, args));
}

/** A tier's name: what the admin typed, or the translated default. */
export function tierName(tier) {
  if (!tier) return '';
  if (tier.name) return tier.name;
  return DEFAULT_TIERS.includes(tier.key) ? lib(`tiers.${tier.key}`) : tier.key;
}

/** Today in the viewer's own calendar, as YYYY-MM-DD. */
export function localToday() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** A season covering today (ranges may wrap the new year: 12-20 → 01-05). */
function seasonToday() {
  const md = localToday().slice(5);
  for (const season of rules()?.seasons || []) {
    const inside = season.from <= season.to ? md >= season.from && md <= season.to : md >= season.from || md <= season.to;
    if (inside) return season;
  }
  return null;
}

/**
 * How a flame looks: the tier's colour and icon, dressed by a season, or gold
 * on the member's birthday when a birthday extension tells us when that is.
 */
export function lookFor(days, user) {
  const tier = tierFor(days);
  const base = {
    color: tier?.color || '#f97316',
    icon: tier?.icon || 'fas fa-fire',
    glow: !!tier?.glow,
    occasion: null
  };
  const birthday = user?.attribute?.('calendarBirthday') || user?.attribute?.('birthday') || null;
  if (birthday && String(birthday).slice(-5) === localToday().slice(5)) {
    return {
      color: '#eab308',
      icon: 'fas fa-cake-candles',
      glow: true,
      occasion: t('birthday')
    };
  }
  const season = seasonToday();
  if (season) return {
    ...base,
    color: season.color,
    icon: season.icon,
    occasion: season.name || null
  };
  return base;
}

/** The public flame on any serialized user: {current, longest} or null. */
export function flameOf(user) {
  const flame = user?.attribute?.('cadenceStreak');
  return flame && typeof flame.current === 'number' ? flame : null;
}

/** The session member's own flame, kept fresh by the visit ping. */
export function ownFlame() {
  return app.session?.user?.attribute?.('cadenceFlame') || null;
}
export function apiUrl(path) {
  return `${app.forum.attribute('apiUrl')}${path}`;
}
flarum.reg.add('ernestdefoe-cadence', 'common/streak/flame', { t: t,rules: rules,streaksOn: streaksOn,tierFor: tierFor,nextTier: nextTier,lib: lib,tierName: tierName,localToday: localToday,lookFor: lookFor,flameOf: flameOf,ownFlame: ownFlame,apiUrl: apiUrl, });